import Header from "./components/Header";
import Banner from "./components/Banner";
import Gallery from "./components/Gallery";
import Footer from "./components/Footer";

function App(){

    const galleryImages = [
        "https://images.unsplash.com/photo-1515879218367-8466d910aaa4",
        "https://images.unsplash.com/photo-1493246507139-91e8fad9978e",
        "https://images.unsplash.com/photo-1519389950473-47ba0277781c",
        "https://images.unsplash.com/photo-1522202176988-66273c2fd55f"
    ];

    return(
        <>
            <Header
                title="Reactor"
                links={["Home", "About", "Team", "Blogs"]}
            />
            <Banner
                title="Welcome to Reactor"
                text="A modern React-based webpage built to create fast, interactive, and responsive user experiences. 
                This project showcases clean design, reusable components, and dynamic functionality using the power of
                 the React library. Explore a smooth and engaging interface designed for modern web development."
            />
            <Gallery images={galleryImages} />
            <Footer />
        </>
    );
}

export default App;